import axios from 'axios'
import { useContext, useState } from 'react'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { db } from '../../lib/firebase-config'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'
import { useHistory } from 'react-router'
import { useAuthentication } from '../Authentication/useAuthentication'
import { useDownload } from '../../hooks/Download/useDownload'
import urlSearchParams from '../../components/urlSearchParams'
import { BeatPlanContext } from '../../context api/BeatPlan/BeatPlanContext'
import { collection, getDocs  } from 'firebase/firestore'
export const UseGeoLocation = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history= useHistory();
  const { addNewBeatPlan, getAllBeatPlans, getBeatPlan, deleteBeatPlan, beatPlans} = useContext(BeatPlanContext)
  const { getPdfCsvData, pdfCsvData, setPdfCsvData } = useDownload();
  const [loading, setLoading] = useState(false)
  const geoDb = collection (db, "geoLocation")
  // const [pdfCsvData, setPdfCsvData] = useState([])

  const getGeos = async (props)=>{
    const data = await getDocs(geoDb);
    console.log(data.docs.map((doc)=>({...doc.data(), id: doc.id})))

  }  
  //CATEGORY

//   const initMap = ()=> {
//     // The location of coordinates
//     const coordinates = { lat: -25.344, lng: 131.031 };
//     // The map, centered at coordinates
//     const map = new google.maps.Map(
//       document.getElementById("map"),
//       {
//         zoom: 4,
//         center: coordinates,
//       }
//     );
  
//     // The marker, positioned at coordinates
//     const marker = new google.maps.Marker({
//       position: coordinates,
//       map: map,
//     });
//   }
  
  // declare global {
  //   interface Window {
  //     initMap: () => void;
  //   }
  // }
  // window.initMap = initMap;
  // export {};



  return {
    loading,
    beatPlans,
    pdfCsvData,
    getGeos
    // initMap
  }
}
